export default {
  hordeEnergyToStr: '+{0} Stärke pro aktueller Energie',
  hordeEnergyToEnergyReg: '+{0} Energieregeneration pro fehlender Energie',
  hordeEnergyOnCrit: '+{0} Energie beim kritischen Treffer',
  hordeHealOnCrit: 'Heilt {0} der maximalen Leben beim kritischen Treffer',
  hordeRestoreCooldownOnCrit: 'Reduziert Abklingzeiten um {0} beim kritischen Treffer',
  hordeBloodOnCrit: 'Erhalte {0} vom gegnerischen Blut beim kritischen Treffer',
  hordeManaRest: 'Erhalte {1} Manaregeneration, wenn {0} keine aktiven Fähigkeiten benutzt werden',
  hordeManasteal: 'Erhalte {0} Mana pro getöteten Gegner',
  hordePassiveRecovery: 'Wende {0} der Erholung jede Sekunde an',
  hordeActiveDamageCrit: 'Aktive Fähigkeiten mit Schaden können mit {0} Effizienz kritisch treffen',
  hordeActiveHealCrit: 'Aktive Fähigkeiten mit Heilung können mit {0} Effizienz kritisch treffen',
  hordeAttackAfterTime: 'Erhalte +{0} Angriff pro Minute im selben Kampf',
  hordeStrIntAfterTime: 'Erhalte {0} Stärke und Intelligenz Angriff pro Minute im selben Kampf',
}
